module.exports = __webpack_public_path__ + "8242f6e88ead455da5822ed8354db9f9.png";


//////////////////
// WEBPACK FOOTER
// ./lib/actradis/resources/img/logo-actradis.png
// module id = 1825
// module chunks = 0